var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"search"}},[_c('b-container',{attrs:{"fluid":""}},[_c('h2',[_vm._v("Under Construction... Please stay tuned :)")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }